export default __webpack_public_path__ + "static/media/illustration.1c9d896b.png";